import React from 'react';
import {useForm} from "@inertiajs/react";
import {route} from "ziggy-js";
import {Breadcrumbs} from "@mui/material";
import useWithStore from "@/Hooks/useWithStore";
import {useModalStore} from "@/Stores/Site/ModalStore";
import Link from "@/Layouts/Link";
import BaseLayout from "@/Layouts/BaseLayout";
import ModalBuyGiftCertificate from "@/Pages/GiftCertificate/ModalBuyGiftCertificate";
import ModalAddNominal from "@/Pages/GiftCertificate/ModalAddNominal";
import Svg from "@/Components/Svg";
import {Error} from "@/Components/Error";
import '@/Pages/GiftCertificate/scss/giftCertificate.scss';

const GiftCertificate = (props) => {
    const {mobileApp = false, stores = {}, imgVersion = '', nominalRange = [], authCheck = false} = props;
    const {modalStore = {}} = stores;
    const minNominal = nominalRange?.minNominal ?? 500;
    const maxNominal = nominalRange?.maxNominal ?? 50000;

    const openModalAuthOrRegister = useModalStore(state => state.openModalAuthOrRegister);

    const initialValues = {certificateNumber: '', errorMessage: ''}

    const {data, setData, post, processing, errors} = useForm(initialValues);

    const onHandleChange = (event) => {
        setData(event.target.name, event.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        post(route('checkCertificate'), {
            preserveScroll: (page) => Object.keys(page.props.errors).length,
        });
    };

    return <BaseLayout {...props}>
        <section className={`section`}>
            {!mobileApp && (
                <div className={`breadcrumbs`}>
                    <div className={`container`}>
                        <Breadcrumbs maxItems={2} itemsAfterCollapse={2}>
                            <Link className={`breadcrumbs__link`} href={`/`}>
                                Главная
                            </Link>
                            <p className={`breadcrumbs__text`}>
                                Подарочный сертификат
                            </p>
                        </Breadcrumbs>
                    </div>
                </div>
            )}
            <div className={`giftCertificate`}>
                <div className={`giftCertificate__header`}>
                    <div className={`container`}>
                        <div className={`giftCertificate__mainContent`}>
                            <div className={`content`}>
                                <p className={`title`}>
                                    Подарочный сертификат PLATINA JEWELRY - отличный выбор
                                </p>
                                <button
                                    className={`btn btn__buyGiftCertificate`}
                                    onClick={() => modalStore.openModalBuyGiftCertificate()}
                                >
                                    Оформить
                                </button>
                            </div>
                            <div className={`image`}>
                                <picture>
                                    <source type={`image/webp`}
                                            srcSet={`/storage/img/giftCertificate/giftCertificate.webp?v=${imgVersion}`}
                                    />
                                    <img className={``}
                                         src={`/storage/img/giftCertificate/giftCertificate.png?v=${imgVersion}`}
                                         alt={`Подарочный сертификат`}
                                         loading={`lazy`}
                                    />
                                </picture>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`container`}>
                    <p className={`giftCertificate__title`}>Электронные подарочные сертификаты PLATINA</p>
                </div>
                <div className={`giftCertificate--advantage`}>
                    <div className={`container`}>
                        <div className={`giftCertificate--advantageContainer`}>
                            <div className={`giftCertificate--advantageItem`}>
                                <div className={`advantageItem__text`}>
                                    <p className={`advantageItem__name`}>
                                        Можно использовать в интернет-магазине или фирменных магазинах PLATINA
                                    </p>
                                </div>
                                <div className={`advantageItem__icon`}>
                                    <Svg id={`certificateAdvantageOne`} className={`svg__certificateStepIcon`} />
                                </div>
                            </div>
                            <div className={`giftCertificate--advantageItem`}>
                                <div className={`advantageItem__text`}>
                                    <p className={`advantageItem__name`}>
                                        Сертификат действует бессрочно
                                    </p>
                                </div>
                                <div className={`advantageItem__icon`}>
                                    <Svg id={`certificateAdvantageTwo`} className={`svg__certificateStepIcon`} />
                                </div>
                            </div>
                            <div className={`giftCertificate--advantageItem`}>
                                <div className={`advantageItem__text`}>
                                    <p className={`advantageItem__name`}>
                                        Используйте номинал сертификата полностью или частями
                                    </p>
                                </div>
                                <div className={`advantageItem__icon`}>
                                    <Svg id={`certificateAdvantageThree`} className={`svg__certificateStepIcon`} />
                                </div>
                            </div>
                            <div className={`giftCertificate--advantageItem`}>
                                <div className={`advantageItem__text`}>
                                    <p className={`advantageItem__name`}>
                                        Отправим сертификат адресату сразу или в указанную дату
                                    </p>
                                </div>
                                <div className={`advantageItem__icon`}>
                                    <Svg id={`certificateAdvantageFour`} className={`svg__certificateStepIcon`} />
                                </div>
                            </div>
                            <div className={`giftCertificate--advantageItem`}>
                                <div className={`advantageItem__text`}>
                                    <p className={`advantageItem__name`}>
                                        Доступен любой номинал
                                        от {minNominal.toLocaleString('ru')}&nbsp;₽
                                        до {maxNominal.toLocaleString('ru')}&nbsp;₽
                                    </p>
                                </div>
                                <div className={`advantageItem__icon`}>
                                    <Svg id={`certificateAdvantageFive`} className={`svg__certificateStepIcon`} />
                                </div>
                            </div>
                            <div className={`giftCertificate--advantageItem`}>
                                <div className={`advantageItem__text`}>
                                    <p className={`advantageItem__name`}>
                                        Дизайн сертификата на ваш выбор
                                    </p>
                                </div>
                                <div className={`advantageItem__icon`}>
                                    <Svg id={`certificateAdvantageSix`} className={`svg__certificateStepIcon`} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`container`}>
                    <p className={`giftCertificate__title`}>Как оформить подарочный сертификат?</p>
                </div>
                <div className={`giftCertificate--stepsDescription`}>
                    <div className={`container`}>
                        <div className={`giftCertificate__steps`}>
                            <div className={`step`}>
                                <div className={`step__text`}>
                                    <p className={`step__name`}>Выберите</p>
                                    <p className={`step__description`}>
                                        Выберите номинал и дизайн сертификата
                                    </p>
                                </div>
                                <div className={`step__icon`}>
                                    <Svg id={`certificateStepIconOne`} className={`svg__certificateStepIcon`} />
                                </div>
                            </div>
                            <div className={`step`}>
                                <div className={`step__text`}>
                                    <p className={`step__name`}>Оплатите</p>
                                    <p className={`step__description`}>
                                        Укажите данные получателя и оплатите покупку сертификата
                                    </p>
                                </div>
                                <div className={`step__icon`}>
                                    <Svg id={`certificateStepIconTwo`} className={`svg__certificateStepIcon`} />
                                </div>
                            </div>
                            <div className={`step`}>
                                <div className={`step__text`}>
                                    <p className={`step__name`}>Подарите</p>
                                    <p className={`step__description`}>
                                        Сертификат будет доставлен по email и/или в SMS
                                    </p>
                                </div>
                                <div className={`step__icon`}>
                                    <Svg id={`certificateStepIconThree`} className={`svg__certificateStepIcon`} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`container`}>
                    <div className={`giftCertificate--checkCertificate`}>
                        <p className={`giftCertificate__title`}>Узнать баланс карты</p>
                        <form className={`form`} onSubmit={handleSubmit}>
                            <div className={`balanceCertificateContainer`}>
                                <div className={`form__itemNew form__itemNew_balanceCertificate`}>
                                    <input name={`certificateNumber`}
                                           type={`number`}
                                           placeholder={``}
                                           value={data.certificateNumber}
                                           onChange={onHandleChange}
                                           className={`text-inputNew${errors.certificateNumber ? ' error' : ''}`}
                                    />
                                    <label className={`text-labelNew`}>Введите номер сертификата *</label>
                                </div>
                                {authCheck ?
                                    <button
                                        className={`btn btn__balanceCertificate mb8`}
                                        type={`submit`}
                                        disabled={processing}
                                    >
                                        Узнать баланс
                                    </button>
                                    :
                                    <div
                                        className={`btn btn__balanceCertificate mb8`}
                                        onClick={openModalAuthOrRegister}
                                    >
                                        Авторизуйтесь, чтобы узнать баланс
                                    </div>
                                }
                            </div>
                            <Error message={errors.certificateNumber} className={`validationError`} />
                        </form>
                    </div>
                    <div className={`fullRules`}>
                        Более подробно с правилами обращения подарочных сертификатов можно
                        ознакомиться <Link href={`/gift-certificate-rules`} className={`fullRules__link`}> здесь.</Link>
                    </div>
                </div>
            </div>
        </section>
        <ModalBuyGiftCertificate {...props} />
        <ModalAddNominal {...props} />
    </BaseLayout>
}

export default useWithStore(GiftCertificate);
